const colors = {
  bloom: {
    100: '#FFEDCF',
    400: '#F4B62E',
    500: '#ECB02D',
    600: '#E2A726',
    900: '#AB7A0C',
  },
  red: {
    500: '#EE584E',
  },
  brand: {
    100: '#ffe5e5',
    200: '#D93B74',
    300: '#f36fa1',
    400: '#D93B74',
    500: '#E31665',
    600: '#d6165b',
    900: '#2C2A2A',
  },
  brandGray: {
    50: '#FFFAFA',
    100: '#F7F5F5',
    200: '#EDE4E4',
    300: '#DED5D5',
    400: '#CCBEBE',
    500: '#8B807F',
    600: '#7F7676',
    700: '#5C5555',
    750: '#2E2B2B',
    800: '#211F1F',
    900: '#0F0E0E',
  },
  gray: {
    1100: '#170E12',
    1000: '#131313',
    900: '#1C1C1C',
    800: '#2C2C2C',
    700: '#3E3E3E',
    600: '#535353',
    500: '#686868',
    400: '#898989',
    300: '#A6A6A6',
    200: '#E7E7E7',
    100: '#F0F0F0',
  },
  black: {
    1000: '#180E1B',
    900: '#2B2C2D',
    800: '#313233',
    700: '#4F2F2F',
  },
  white: {
    1000: '#FFF',
    900: '#EEE',
  },
  yellow: {
    100: '#FFFBEB',
    200: '#FFF9D8',
    300: '#FEF3C2',
    400: '#E3DEC3',
    500: '#FEE886',
    600: '#FDE05D',
    700: '#FDD835',
    800: '#FDCF08',
    900: '#D4AD02',
  },
  gold: {
    50: '#FFF6E8',
    100: '#FFEDCF',
    200: '#FFE3B5',
    300: '#FAD8A1',
    400: '#F4CC89',
    500: '#EBBC6F',
    600: '#E4AD51',
    700: '#DD9D34',
    800: '#D28D1A',
    900: '#AF730D',
  },
  purple: {
    50: '#CBBEEA',
    100: '#BEAFE6',
    200: '#B19FE1',
    300: '#A590DC',
    400: '#8C71D2',
    500: '#7352C8',
    600: '#5D3AB7',
    700: '#4B2F94',
    800: '#311E60',
    900: '#D4AD02',
  },
  blue: {
    50: '#eaf4fd',
    100: '#bee3f8',
    200: '#90cdf4',
    300: '#63b3ed',
    400: '#4299e1',
    500: '#3182ce',
    600: '#2b6cb0',
    700: '#2c5282',
    800: '#2a4365',
    900: '#1A365D',
  },
  green: {
    50: '#F0FFF4',
    100: '#C2E6DB',
    200: '#AAD5C8',
    300: '#93CCBB',
    400: '#7CC4AF',
    500: '#5ABA9D',
    600: '#4FA58B',
    700: '#479980',
    800: '#36846C',
    900: '#235E4D',
  },
}

export default colors
